// extracted by mini-css-extract-plugin
module.exports = {"shadow-box":"ShadowBox_shadow-box__V0ftb","trial":"ShadowBox_trial__a_n_o"};